import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Storage } from '@ionic/storage';
import { Globalization } from '@ionic-native/globalization';

export enum LanguageEnum {
  ES = 'es',
  EN = 'en',
  PT = 'pt',
}

@Injectable()
export class LanguageProvider {

  constructor(
    public http: HttpClient,
    private storage: Storage,
    private globalization: Globalization
  ) {
  }

  private async getPreferredLanguage(): Promise<LanguageEnum | string>  {
    try {
      const language = await this.globalization.getPreferredLanguage();
      const handleLanguage = language.value.substr(0,2).toLowerCase();
      
      if(handleLanguage === LanguageEnum.EN ) {
        return LanguageEnum.EN;
      }

      if(handleLanguage === LanguageEnum.ES ) {
        return LanguageEnum.ES;
      }

      return LanguageEnum.ES;
    } catch(e) {
      return LanguageEnum.ES;
    }
  }

  async get(): Promise<LanguageEnum | string> {
    let lang = await this.storage.get('language');

    if(!lang) {
      lang = await this.getPreferredLanguage();
      this.set(lang);
    }

    return lang;
  }

  async set(lang: LanguageEnum) {
    await this.storage.set('language', lang);
  }

}



// WEBPACK FOOTER //
// ./src/providers/language/language.ts